let loginIntent = null

export const createLoginIntent = () => {
  if (loginIntent) return loginIntent.promise

  let resolveIntent
  const promise = new Promise((resolve) => {
    resolveIntent = resolve
  })
  loginIntent = { promise, resolve: resolveIntent }
  return promise
}

export const finishLoginIntent = (result) => {
  if (!loginIntent) return
  const intent = loginIntent
  loginIntent = null
  intent.resolve(result)
}

export const hasLoginIntent = () => Boolean(loginIntent)
